import * as React from "react";
import { forwardRef } from "react";
const SvgIcMail24 = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M12 12.5859L17.5859 7H19V8.41406L12.707 14.707H11.293L5 8.41406V7H6.41406L12 12.5859Z", fill: "currentColor" }), /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M22 5V19L21 20H3L2 19V5L3 4H21L22 5ZM4 18H20V6H4V18Z", fill: "currentColor" }));
const ForwardRef = forwardRef(SvgIcMail24);
export { ForwardRef as ReactComponent };
